import { render, staticRenderFns } from "./ModalProjectCustomerPurchaseOrders.vue?vue&type=template&id=8eb538d4&scoped=true&lang=pug&"
import script from "./ModalProjectCustomerPurchaseOrders.vue?vue&type=script&lang=js&"
export * from "./ModalProjectCustomerPurchaseOrders.vue?vue&type=script&lang=js&"
import style0 from "./ModalProjectCustomerPurchaseOrders.vue?vue&type=style&index=0&id=8eb538d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb538d4",
  null
  
)

export default component.exports